import axios from "axios";
import { getInitData } from "./telegram";

const API_URL = import.meta.env.VITE_API_URL ?? "http://localhost:3001";

export const api = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const initData = getInitData();
  if (initData) {
    config.headers["x-telegram-init-data"] = initData;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    if (
      typeof error === "object" &&
      error !== null &&
      "response" in error &&
      (error as { response?: { status?: number } }).response?.status === 401
    ) {
      console.error("Auth error — initData invalid or expired");
    }
    return Promise.reject(error);
  },
);
